/* sb-dc-tplfaq.js - the FAQ on the design templates page. 2026-10-08.

   Replaces the two boxes the page shipped with - the "Choose a design below to
   get started..." line (details.sbdt-intro) and "Instructions"
   (details.sbdt-howto) - with a titled FAQ: an "FAQ" header row and six
   questions about designing a step & repeat. The originals are hidden, not
   deleted, so turning this file off brings them straight back.

   2026-10-09 (theme "DC la", store's request): ONE question per row (was two
   columns), and the whole card now sits BELOW the pattern grid instead of
   above it. Below the grid the height no longer pushes the patterns down, so
   the two-column squeeze is gone. The card (.sbdt-help) is moved to the end of
   .sbdt-main - same column as the grid, the category sidebar stays on the
   left - and a comment marker is left where it was, so switching to a product
   that does not get the FAQ puts the card (with its original intro and
   Instructions boxes) back in its old place above the grid.

   Step & repeat galleries only, same test the video button uses
   (assets/sb-dc-tplvideo.js): the gallery is one page serving every product,
   and the customer can change product in #sbdt-product without the address
   changing, so the dropdown's selected TEXT is what decides - its values are a
   mix of list indexes ("5") and flag handles ("sbflag:teardrop-flag-small").
   On any other product the page is left exactly as it was, originals included.

   Everything is built inside the page's own .sbdt-help card and each question
   reuses the class the old Instructions box used, so the card, the rule between
   rows and the +/- marker are the page's own styling rather than a second look
   invented here. Only the layout and type are set here - see css().

   The section file is sections/sb-dc-templates.liquid - 84KB of markup, script
   and styles. It is not touched; this is added alongside it, which is also why
   the page re-renders its own parts freely and placement is re-checked on a
   timer. */
(function () {
  'use strict';

  var HELP = '.sbdt-help';
  var MAIN = '.sbdt-main';            /* the column holding search + grid */
  var SELECT_ID = 'sbdt-product';
  var MINE = 'sbdt-faqitem';          /* marks the rows this file adds */
  var HEAD = 'sbdt-faqhead';          /* the title row above them */
  var TITLE = 'FAQ';
  var SUB = 'Designing your Step & Repeat backdrop';
  var ON = 'sbdt-faq-on';             /* on the card: hides the originals */
  var CSS_ID = 'sbdt-faq-css';
  var VID_BTN = 'sbdt-vidbtn';        /* the Step & Repeat Video button */
  /* Used only until the button is on the page - see tone(). */
  var FALLBACK_BG = '#FAD89D', FALLBACK_INK = '#072747';

  /* The questions, in order, one per row. Keep the wording here - it is the
     only copy. */
  var FAQ = [
    {
      q: 'Do I need design software or design skills?',
      a: 'Not at all! Our Design Center is designed for everyone, even if you ' +
         'have no graphic design experience. Pick a ready-made pattern, drop in ' +
         'your logo, and you’re done. Already have finished artwork? Upload it ' +
         'and skip straight ahead!'
    },
    {
      q: 'Do I have to place every single logo myself?',
      a: 'Never! The patterns are already built for you. Drop your logo in once ' +
         'and watch it fill the entire backdrop instantly — no tedious ' +
         'one-by-one placing.'
    },
    {
      q: 'Can I upload my own logo or artwork?',
      a: 'Yes! You can upload your own logo or artwork directly into our Design ' +
         'Center. For the best printing results, we recommend using ' +
         'high-resolution images with transparent backgrounds, such as PNG files.'
    },
    {
      q: 'Can I control how the logos look?',
      a: 'Absolutely! Make them bigger, make them smaller, tighten or loosen the ' +
         'spacing, switch between aligned and staggered. It’s your call — and ' +
         'every change shows up live on screen the moment you make it.'
    },
    {
      q: 'Can I come back and finish my design later?',
      a: 'Yes! If you close the tab, your design is saved right in your browser. ' +
         'Come back on the same device within 14 days and you’ll see a ' +
         '“Pick up where I left off” bar at the bottom — one click and you’re ' +
         'back in. Just note it saves your most recent design only, and it’s ' +
         'tied to that browser, so clearing your history or switching to another ' +
         'device or phone will start you fresh. Finished a design you love? Add ' +
         'it to your cart to lock it in!'
    },
    {
      q: 'Do I choose the size and finishing in the Design Center?',
      a: 'Yes. Set your size first, then choose your finishing — hem and ' +
         'grommets, pole pockets, and so on. The options shown are the ones ' +
         'available for the material you picked, so vinyl and fabric differ.'
    }
  ];

  /* ---- which gallery gets the FAQ -------------------------------------- */

  function wanted() {
    var sel = document.getElementById(SELECT_ID);
    if (!sel) return false;
    var opt = sel.options[sel.selectedIndex];
    var t = (opt ? opt.text : '').toLowerCase();
    if (!t) return false;
    if (t.indexOf('step') > -1 && t.indexOf('repeat') > -1) return true;
    /* Pop-up display backdrops count as step & repeat - the store's ruling, and
       the product pages and design center already treat them that way. */
    if (t.indexOf('pop-up display backdrop') > -1) return true;
    return false;
  }

  /* ---- styling ---------------------------------------------------------- */

  function css() {
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent =
      '.' + ON + ' > details:not(.' + MINE + '){display:none !important}' +
      /* 2026-10-09: one column, under the grid. The page gives the card
         margin 0 0 14px for its old spot above the search row; here the gap
         goes above it instead, away from the last row of patterns.
         Two classes on purpose: the page's own .sbdt-help rule loads AFTER
         this <style> (it is in the section), so a one-class selector loses. */
      '.sbdt-help.' + ON + '{display:block;margin:22px 0 0}' +
      /* The title row. No bottom rule of its own - the first question's own
         top rule already draws that line. */
      '.' + HEAD + '{padding:10px 20px;display:flex;' +
      'flex-wrap:wrap;align-items:baseline;gap:3px 10px;border-radius:9px 9px 0 0}' +
      '.' + HEAD + ' b{font-size:15.5px;line-height:1.3;font-weight:800;' +
      'letter-spacing:-.01em}' +
      /* The subtitle is the same ink at 70%, so it sits back without
         introducing a grey that fights the fill. */
      '.' + HEAD + ' span{font-size:12px;line-height:1.4;opacity:.7}' +
      /* The page's own row padding is 13px 20px; these are a little tighter. */
      '.' + MINE + '.sbdt-howto{padding:10px 20px}' +
      /* The questions are set normal, not bold, and a step down from the page's
         own size (.92em of 16.8px ~ 15.5px) - six bold rows in a row read as
         six headings rather than one list. The <h2> the markup uses for them
         has to be told both: a heading is bold by default. */
      '.' + MINE + ' > summary h2{display:flex;gap:9px;align-items:baseline;margin:0;' +
      'font-size:.92em;line-height:1.45;font-weight:400;text-transform:none;letter-spacing:0}' +
      /* The number keeps its weight - it is the one thing still holding the
         rows apart now that the questions are light. */
      '.' + MINE + ' .sbdt-faqn{flex:0 0 auto;color:#FD913E;font-weight:700}' +
      '.' + MINE + ' .sbdt-faqa{margin:7px 0 1px;padding:0;' +
      'font-size:.86em;line-height:1.55;color:#3d4852}';
    document.head.appendChild(st);
  }

  /* The header is filled with the Step & Repeat Video button's own colours
     (store's request). They are READ OFF that button at runtime rather than
     written down here: the button's fill has already been restyled once, and a
     second hard-coded copy of it would quietly drift apart from it. The
     constants above are only for the moment before the button exists.
     Rounded at the top so the fill follows the card's own corners. */
  function tone(head) {
    var b = document.getElementById(VID_BTN);
    var bg = FALLBACK_BG, ink = FALLBACK_INK;
    if (b) {
      var cs = window.getComputedStyle(b);
      if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') bg = cs.backgroundColor;
      if (cs.color) ink = cs.color;
    }
    if (head.style.background !== bg) head.style.background = bg;
    if (head.style.color !== ink) head.style.color = ink;
  }

  /* ---- the rows --------------------------------------------------------- */

  function build(card) {
    /* The header carries MINE too, so it is cleared with the questions when the
       customer switches to a product that does not get the FAQ. */
    var head = document.createElement('div');
    head.className = HEAD + ' ' + MINE;
    var t = document.createElement('b');
    t.textContent = TITLE;
    var sub = document.createElement('span');
    sub.textContent = SUB;
    head.appendChild(t);
    head.appendChild(sub);
    tone(head);
    card.appendChild(head);

    FAQ.forEach(function (item, i) {
      var d = document.createElement('details');
      /* sbdt-howto is the page's own row class - same card rule and +/- marker
         as the box this replaces. */
      d.className = 'sbdt-howto ' + MINE;

      var sum = document.createElement('summary');
      var h = document.createElement('h2');
      var n = document.createElement('span');
      n.className = 'sbdt-faqn';
      n.textContent = (i + 1) + '.';
      var qt = document.createElement('span');
      qt.textContent = item.q;
      h.appendChild(n);
      h.appendChild(qt);
      sum.appendChild(h);

      var p = document.createElement('p');
      p.className = 'sbdt-faqa';
      p.textContent = item.a;        /* text, so quotes and dashes stay literal */

      d.appendChild(sum);
      d.appendChild(p);
      card.appendChild(d);
    });
  }

  /* ---- where the card sits ---------------------------------------------- */

  /* A comment left in the card's original spot (above the picker / search
     row), so it can be put back exactly there. */
  var slot = null;

  function moveDown(card) {
    var main = document.querySelector(MAIN);
    if (!main) return;
    if (!slot && card.parentNode && card.parentNode !== main) {
      slot = document.createComment('sbdt-help original position');
      card.parentNode.insertBefore(slot, card);
    }
    /* Last thing in the grid column - after the grid and its "more" button.
       Re-checked every tick in case the page appends to the column. */
    if (main.lastElementChild !== card) main.appendChild(card);
  }

  function moveBack(card) {
    if (slot && slot.parentNode && card.previousSibling !== slot) {
      slot.parentNode.insertBefore(card, slot.nextSibling);
    }
  }

  function place() {
    var card = document.querySelector(HELP);
    if (!card) return;

    if (!wanted()) {
      /* Another product: give the page back exactly what it had. */
      card.classList.remove(ON);
      var mine = card.querySelectorAll('.' + MINE);
      for (var i = 0; i < mine.length; i++) {
        if (mine[i].parentNode) mine[i].parentNode.removeChild(mine[i]);
      }
      moveBack(card);
      return;
    }

    css();
    card.classList.add(ON);
    if (!card.querySelector('.' + MINE)) build(card);
    moveDown(card);

    /* Re-read the button's colours each tick: it is added by another file
       (assets/sb-dc-tplvideo.js) and may land after the header does. */
    var head = card.querySelector('.' + HEAD);
    if (head) tone(head);
  }

  function start() {
    place();
    /* The gallery rebuilds parts of the page as filters change, and the product
       dropdown can change without a page load. */
    var t = setInterval(function () { try { place(); } catch (e) {} }, 500);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
